<template>
<div>
    <div class="content">
        <div class="cont-list">
            <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        </div>
        <div class="header">
            <div class="left">
                <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
            </div>
        </div>

        <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <template slot="empty">
                <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                    <img src="../../../../assets/noData.png" width="240" height="240" />
                    <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                    <div class="empty-rest" @click="reset">恢复默认</div>
                </div>
            </template>

            <el-table-column prop="no" label="供应商产品编码" min-width="150">
              <template slot-scope="scope">
                <span>
                  <el-link type="primary" @click="viewEvt(scope.row)">{{ scope.row.no }}</el-link>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="产品注册证" width="180" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.productRegistCertBexpireNum==0&&scope.row.productRegistCertRecentNum==0">-</div>
                    <div v-if="scope.row.productRegistCertBexpireNum !=0" style="color:red">已过期{{ scope.row.productRegistCertBexpireNum }}</div>
                    <div v-if="scope.row.productRegistCertRecentNum !=0" style="color:orange">即将过期{{ scope.row.productRegistCertRecentNum }}</div>
                </template>
            </el-table-column>
            <el-table-column label="授权链" width="180" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.delegationChainBexpireNum==0&&scope.row.delegationChainRecentNum==0">-</div>
                    <div v-if="scope.row.delegationChainBexpireNum != 0" style="color:red">已过期{{ scope.row.delegationChainBexpireNum }}</div>
                    <div v-if="scope.row.delegationChainRecentNum !=0" style="color:orange">即将过期{{ scope.row.delegationChainRecentNum }}</div>
                </template>
            </el-table-column>
            <el-table-column label="生产厂家证件" align="center" width="140">
                <template slot-scope="scope">
                    <div v-if="scope.row.manufacturerCertBexpireNum==0&&scope.row.manufacturerCertRecentNum==0">-</div>
                    <div v-if="scope.row.manufacturerCertBexpireNum !=0" style="color:red">已过期{{ scope.row.manufacturerCertBexpireNum }}</div>
                    <div v-if="scope.row.manufacturerCertRecentNum !=0" style="color:orange">即将过期{{ scope.row.manufacturerCertRecentNum }}</div>

                </template>
            </el-table-column>
            <el-table-column label="供应商证件" align="center" width="140" prop="address">
                <template slot-scope="scope">
                    <div v-if="scope.row.mySupplierCertBexpireNum==0&&scope.row.mySupplierCertRecentNum==0">-</div>
                    <div v-if="scope.row.mySupplierCertBexpireNum !=0" style="color:red">已过期{{ scope.row.mySupplierCertBexpireNum }}</div>
                    <div v-if="scope.row.mySupplierCertRecentNum !=0" style="color:orange">即将过期{{ scope.row.mySupplierCertRecentNum }}</div>
                </template>
            </el-table-column>
            <el-table-column label="生产厂家" min-width="120" align="center" prop="manufacturerName" />
            <el-table-column prop="supplierName" label="供应商" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="operation" label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="text" v-preventReClick @click="viewEvt(scope.row)" class="color-blue">查看</el-button>
                </template>
            </el-table-column> -->
        </el-table>

    </div>
    <div class="pagination">
        <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
        </el-pagination>
    </div>

    <el-dialog title="查看" :visible.sync="show" width="60%" @open="openEvt" :show-close="false" :close-on-click-modal="false" @close="bindingClose">
        <div style="margin-bottom: 10px">
            <el-tabs v-model="approveState" @tab-click="tabClick" stretch>
                <el-tab-pane v-for="item in SupplierOrderStateArray" :key="item.id" :name="item.id + ''">
                    <template slot="label">
                        <el-badge :value="item.count" :max="99" class="item">
                            <span style="margin: 0 10px"> {{ item.name }} </span>
                        </el-badge>
                    </template>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-table ref="multipleTable" border row-key="id" :data="viewList" :height="500" style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column v-if="approveState==0" prop="name" label="注册证名称" min-width="100" show-overflow-tooltip :key="'name'"/>
            <el-table-column v-if="approveState==0" prop="no" label="注册证号" min-width="100" show-overflow-tooltip :key="'no1'" />
            <el-table-column v-if="approveState==0" prop="manufacturerName" label="生产厂家" min-width="100" show-overflow-tooltip  :key="'manufacturerName'"/>
            <el-table-column v-if="approveState==1" prop="no" label="授权链编号" min-width="100" show-overflow-tooltip :key="'no'"/>
            <el-table-column v-if="approveState==1"  label="授权产品 规格型号" min-width="100" show-overflow-tooltip :key="'specName'">
                <template slot-scope="scope">
                    <div class="box">
                        <div v-for="(item,index) in scope.row.products" :key="item.id">
                            <p>{{ index+1 }}. {{ item.name+' '+ item.specName}} </p>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="approveState==2||approveState==3" prop="no" label="证件编号" min-width="100" show-overflow-tooltip  :key="'no4'"/>
            <el-table-column v-if="approveState==2||approveState==3" prop="categoryName" label="证件类型" min-width="100" show-overflow-tooltip :key="'categoryName'"/>
            <el-table-column v-if="approveState==2||approveState==3" prop="name" label="证件名称" min-width="100" show-overflow-tooltip  :key="'no5'"/>
            <el-table-column label="生效日期" align="center" width="150" prop="startDate">
                <template slot-scope="scope">
                    <span>{{

                    parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}")
                  }}</span>
                </template>
            </el-table-column>
            <el-table-column label="失效日期" align="center" width="150" prop="endDate">
                <template slot-scope="scope">
                    <span>{{ parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}") }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="overdueName" label="效期状态" min-width="100" show-overflow-tooltip :key="'overdueName'">
              <template slot-scope="scope">
                <span v-if="scope.row.overdueName == '即将过期'" style="color:orange">
                  {{ scope.row.overdueName }} ( {{ intervalTime(scope.row.endDate)}} )天
                </span>
                <p v-if="scope.row.overdueName == '已过期'" style="color:red">
                  {{ scope.row.overdueName }} ( {{ intervalTime(scope.row.endDate) }} ) 天
                </p>
                <p v-if="scope.row.overdueName == '正常'">{{ scope.row.overdueName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="证件附件" v-if="approveState!=1" align="center" width="180" :key="'fileInfos'">
                <template slot-scope="scope" >
                    <div v-for="file in scope.row.fileInfos" :key="file.id">
                        <el-button type="text" size="medium" @click.stop="privewImg(file)">{{file.name}}</el-button>
                        <!-- <el-image-viewer :filePath=x"file.path" :fileName="file.name" /> -->
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="operation" label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="text" v-preventReClick class="color-blue" @click="goEvt(scope.row)">查看</el-button>
                </template>
            </el-table-column> -->
        </el-table>

        <div slot="footer" class="dialog-footer">
            <el-button class="btn" size="small" @click="bindingClose">取 消</el-button>
            <el-button class="btn primary" type="primary" size="small" @click="bindingClose">确 定</el-button>
        </div>
    </el-dialog>
    <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />
</div>
</template>

<script>
import {
    GetDocumentWarnings,
    GetProductCertsByIds,
    GetManufacturerCertsByIds,
    GetMySupplierCertsByIds,
    GetAuthorizechainsByIds,
} from "@/api"
import GetDataMixin from "@/mixin/getData-mixin.js"
import SelectFilter from "@/components/table-select-filter"
import ElImageViewer from "@/components/elImageViewer";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
export default {
    mixins: [GetDataMixin,GetDataSpdMixin],
    components: {
        SelectFilter,
        ElImageViewer
    },
    data() {
        return {
            // 查询条件
            query: {
                pageSize: 10,
                pageIndex: 1,
            },
            // 列表数据
            tableData: [],
            // 列表总数
            total: 0,
            // 弹出框标题
            title: "",
            filterOptions: [{
                    name: "供应商产品",
                    type: "input",
                    code: "keyWord",
                },
                {
                    name: "生产厂家",
                    type: "input",
                    code: "manufacturerName",
                },
                {
                    name: "供应商",
                    type: "input",
                    code: "supplierName",

                },
            ],
            SupplierOrderStateArray: [{
                id: 0,
                count: 0,
                name: "产品注册证",
            }, {
                id: 1,
                count: 0,
                name: "授权链",
            }, {
                id: 2,
                count: 0,
                name: "生产厂家",
            }, {
                id: 3,
                count: 0,
                name: "供应商",
            }],
            approveState: '0',
            show: false,
            viewRow: {},
            viewList: [],
            dialogVisible: false,
            dialogImageUrl: "",
            fileName: "",
            fileId: 0,
        };
    },
    methods: {
        filterChange(query) {
            this.query = Object.assign(this.query, query);
            this.getData()
        },
        // 获取列表
        getData() {
            // this.tableData.push({})
            GetDocumentWarnings(this.query).then(res => {
                this.tableData = res.returnData.data
                console.log(res);

            })

        },
        //查看
        viewEvt(row) {
            this.viewRow = row
            this.SupplierOrderStateArray[0].count = row.productRegistCertIds.length
            this.SupplierOrderStateArray[1].count = row.delegationChainIds.length
            this.SupplierOrderStateArray[2].count = row.manufacturerCertIds.length
            this.SupplierOrderStateArray[3].count = row.mySupplierCertIds.length
            this.show = true
        },
        // 改变当前页
        changePage(val) {
            this.$set(this.query, "pageIndex", val);
            this.getData();
        },
        handleSizeChange(val) {
            this.$set(this.query, "pageSize", val);
            this.getData();
        },
        // 获取授权链信息
        getDelegation() {
            GetAuthorizechainsByIds({
                ids: this.viewRow.delegationChainIds
            }).then(res => {
                this.viewList = res.returnData
            })
        },
        // 获取我的供应商信息
        getMySupplier() {
            GetMySupplierCertsByIds({
                ids: this.viewRow.mySupplierCertIds
            }).then(res => {
                this.viewList = res.returnData
            })
        },
        // 获取生产厂家
        getManufacturer() {
            GetManufacturerCertsByIds({
                ids: this.viewRow.manufacturerCertIds
            }).then(res => {
                this.viewList = res.returnData
            })
        },
        // 获取产品注册证
        getProduct() {
            GetProductCertsByIds({
                ids: this.viewRow.productRegistCertIds
            }).then(res => {
                this.viewList = res.returnData
            })
        },
        // 重置
        reset() {
            this.query.keyWord = "";
            this.$set(this.query, "pageIndex", 1);
            this.$set(this.query, "pageSize", 10);
            this.ids = []
            this.multipleSelection = []
            this.multiple = true;
            if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection()
            }
            this.getData();
        },
        queryChange() {
            this.$set(this.query, "pageIndex", 1);
            this.getData();
        },
        tabClick(val) {
            this.approveState = val.index
            if (val.index == '0') {
                this.getProduct()
            } else if (val.index == '1') {
                this.getDelegation()
            } else if (val.index == '2') {
                this.getManufacturer()
            } else {
                this.getMySupplier()
            }
            // this.query.approveState = val.index;
            // this.getData();
        },
        bindingClose() {
            this.approveState = '0'
            this.show = false
        },
        openEvt() {
            this.getProduct()
        },
        closeImageViewer() {
            this.dialogVisible = false;
        },
        privewImg(file) {
            // this.dialogImageUrl = file.path;
            // this.dialogVisible = true;
            this.dialogVisible = true;
            this.fileId = file.id;
            this.fileName = file.name;
        },
    },
    mounted() {
        this.getData();
    },
};
</script>

<style lang="scss" scoped>
.el-tabs {
    width: 800px;
    // margin-bottom: 10px;
}

/deep/.el-badge__content.is-fixed {
    top: 10px !important;
    right: 16px !important;
}

/deep/.el-tabs--top .el-tabs__item.is-top:last-child,
.el-tabs--top .el-tabs__item.is-bottom:last-child,
.el-tabs--bottom .el-tabs__item.is-top:last-child,
.el-tabs--bottom .el-tabs__item.is-bottom:last-child {
    padding-right: 20px !important;
}

.box {
    max-height: 120px;
    overflow-x: hidden;
}
</style>
